import { lazy } from 'react'

import { AnyRoute, createRoute } from '@tanstack/react-router'
import { z } from 'zod'
import {
  ONBOARDING_DOCUMENT_DETAILS_KEY,
  onboardingDocumentDetailsQueryOptions
} from '~bank-onboarding-documents/service/onboardingDocumentDetailsQueryOptions'

import { SetupDocumentsViewDetailsContextProvider } from './context/SetupDocumentsViewDetailsContextProvider'

const SetupDocumentsViewDetails = lazy(() => import('./SetupDocumentsViewDetails'))

const schema = z.object({
  historyPage: z.number().optional(),
  historySize: z.number().optional()
})

export const setupDocumentsViewDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '$id/details',
    validateSearch: (search) => schema.parse(search),
    loaderDeps: ({ search }) => ({
      search
    }),
    loader: ({ cause, deps, params, context }) => {
      const opts = { id: Number(params.id), page: deps.search.historyPage, size: deps.search.historySize }
      if (cause === 'stay') {
        return context.queryClient.getQueryData([ONBOARDING_DOCUMENT_DETAILS_KEY, opts]) ?? null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(onboardingDocumentDetailsQueryOptions(opts))
    },
    component: () => (
      <SetupDocumentsViewDetailsContextProvider>
        <SetupDocumentsViewDetails />
      </SetupDocumentsViewDetailsContextProvider>
    )
  })
